import BaseServices from "./BaseServices";

const PlatformServices = {
    PlatformStoresUser: async (platforms, status, productId = 0) => {
        return await BaseServices.Post(`/api/connectPlatform/get-stores-platform/${productId}?status=${status}`, platforms);
    },
    DeleteConnectStore: async (id) => {
        return await BaseServices.Post(`/api/connectPlatform/delete-connect-store/${id}`);
    },
    GetWebhooksUrl: async (platform) => {
        return await BaseServices.Get(`/api/connectPlatform/get-webhooks-url?platform=${platform}`);
    },
    //lấy danh sách ngành hàng theo platform
    GetCategories: async (paging) => {
        return await BaseServices.Post("/api/Category/get-list-parent-category", paging);
    },
    //sync sản phẩm trên platform về FIFO
    SyncProductsToFiFo: async (model) => {
        return await BaseServices.Post("/api/agencyproducts/sync-products", model);
    },
    //sync sản phẩm trên platform về FIFO
    CheckAdminConnectPlatform: async (platform) => {
        return await BaseServices.Post("/api/connectPlatform/check-connect-platform?platform=" + platform, null);
    },
    ConnectToPlatform: async (param) => {
        return await BaseServices.Get("/api/connectPlatform/connect-to-platform" + (param ? param : ""));
    },
    ConnectToSendo: async (obj) => {
        return await BaseServices.Post("/api/connectPlatform/connect-to-sendo", obj);
    },
    RefreshAccessToken: async (model) => {
        return await BaseServices.Post(`/api/connectPlatform/refresh-access-token`, model);
    },
    //sync thuộc tính
    SyncAttributes: async (model) => {
        return await BaseServices.Post("/api/connectPlatform/sync-attributes/", model);
    },
    UpdateSetIsActiveShop: async (platform, shopId, isActive) => {
        return await BaseServices.Get(`/api/platform/update-set-is-active-shop?platform=${platform}&shopId=${shopId}&isActive=${isActive}`);
    },
    GetPartnerPlatform: async (tokenId) => {
        return await BaseServices.Get(`/api/platform/get-partner-platform/${tokenId}`);
    },
    CreateImageShop: async (model) => {
        return await BaseServices.Post("/api/platform/create-image-shop", model);
    },
    SwitchPackageCost: async (tokenId) => {
        return await BaseServices.Get(`/api/platform/switch-package-cost/${tokenId}`);
    },
    UpdateIndexDefaultImage: async (model) => {
        return await BaseServices.Post("/api/platform/update-index-default-image", model);
    },
    GetBrands: async (shopId) => {
        return await BaseServices.Get(`/api/platform/get-brands?shopId=${shopId}`);
    },
    CreateUpdatePlatformBrand: async (model) => {
        return await BaseServices.Post("/api/platform/create-update-platform-brand", model);
    },
    SetDefaultBrand: async (model) => {
        return await BaseServices.Post("/api/platform/set-default-brand", model);
    },
    RemovePlatformBrand: async (id) => {
        return await BaseServices.Get(`/api/platform/remove-platform-brand/${id}`);
    },
    GetTemplateDTOs: async (model) => {
        return await BaseServices.Post("/api/platform/get-template-dtos", model);
    },
    CreateUpdateTemplate: async (model) => {
        return await BaseServices.Post("/api/platform/create-update-template", model);
    },
    RemoveTemplateDTO: async (id) => {
        return await BaseServices.Get("/api/platform/remove-template-dto/" + id);
    },
};
export default PlatformServices;
